exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-container[data-v-ef27882a]{position:relative;overflow-y:auto}.table[data-v-ef27882a]{position:absolute;top:0;bottom:0;left:0;right:0;overflow-y:auto;margin-top:0;margin-bottom:0}", ""]);

// exports
